<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy"
    [buttonTemplate]="buttonTemplate" [modalHelpIndex]="modalHelpIndex" [(isBusyMessage)]="isBusyMessage"
    [modalClass]="modalClass" [modalHasVariableHeight]="true">
    <div class="nameDescriptionSection">
        <div class="nameTypeClass">
            <div class="modal-row">
                <div class="modal-row-column-auto group-label">
                    <label for="name" [class.disabled]="isEditConnector" requiredAsterisk
                        [isRequired]="!isEditConnector">Name:
                    </label>
                </div>
                <div class="modal-row-column-fixed">
                    <input type="text" [attr.maxlength]=drObject.maxNameLength id="nameId" [(ngModel)]="name"
                        [disabled]="isEditConnector" data-automation-id="connector-modal-name-input"
                        (ngModelChange)="onNameChanged()" class="error-popover" containerClass="error" container="body"
                        [popover]="errorPopoverTemplate" triggers="" #errorPopover="bs-popover" placement="bottom"
                        (focusout)="onNameFocusLost()" (focus)="onNameChanged()">
                    <ng-template #errorPopoverTemplate>
                        <span data-automation-id="connector-modal-name-error-label">{{validateNameError}}</span>
                        <i class="fa fa-close" (click)="errorPopover.hide()"></i>
                    </ng-template>
                </div>
                 <div class="modal-row-column-auto">
                    <label for="description">Description:</label>
                </div>
                <div class="modal-row-column-max description">
                    <input id="description" type="text" [(ngModel)]="description"
                        data-automation-id="connector-modal-description-input"
                        [attr.maxlength]=drObject.maxDescriptionLength title="255 characters max." name="description"
                        (ngModelChange)="onDescriptionChanged()" (focusout)="onDescriptionFocusLost()"/>
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto group-label typeLabel">
                    <label for="type" [class.disabled]="isEditConnector" requiredAsterisk
                        [isRequired]="!isEditConnector">Type:
                    </label>
                </div>
                <div class="modal-row-column-max type">
                    <button data-automation-id="connector-modal-nfs-button" type="button"
                        [ngClass]="connectorType === ConnectorType.NFS ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setType(ConnectorType.NFS)" [disabled]="isEditConnector">
                        <div>NFS</div>
                        <i class="fa fa-caret-up up-caret-active" [hidden]="connectorType !== ConnectorType.NFS"></i>
                    </button>
                    <button data-automation-id="connector-modal-cifs-button" type="button"
                        [ngClass]="connectorType === ConnectorType.CIFS ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setType(ConnectorType.CIFS)" [disabled]="isEditConnector">
                        <div>CIFS</div>
                        <i class="fa fa-caret-up up-caret-active" [hidden]="connectorType !== ConnectorType.CIFS"></i>
                    </button>
                    <button data-automation-id="connector-modal-type-ms-exchange-button" type="button"
                        [ngClass]="connectorType === ConnectorType.MSExchange ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setType(ConnectorType.MSExchange)" [disabled]="isEditConnector">
                        <div>MS&nbsp;Exchange</div>
                        <i class="fa fa-caret-up up-caret-active"
                            [hidden]="connectorType !== ConnectorType.MSExchange"></i>
                    </button>
                    <button data-automation-id="connector-modal-type-ms-sharepoint-button" type="button"
                        [ngClass]="connectorType === ConnectorType.MSSharePoint ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setType(ConnectorType.MSSharePoint)" [disabled]="isEditConnector">
                        <div>MS&nbsp;SharePoint</div>
                        <i class="fa fa-caret-up up-caret-active"
                            [hidden]="connectorType !== ConnectorType.MSSharePoint"></i>
                    </button>
                    <button data-automation-id="connector-modal-type-google-workspace-button" type="button"
                        [ngClass]="connectorType === ConnectorType.GoogleWorkspace ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setType(ConnectorType.GoogleWorkspace)" [disabled]="isEditConnector">
                        <div>Google&nbsp;Workspace</div>
                        <i class="fa fa-caret-up up-caret-active"
                            [hidden]="connectorType !== ConnectorType.GoogleWorkspace"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="section-heading">
        Connector Configuration
    </div>
    <div class="nfsSection" *ngIf="connectorType === 'NFS'"
        data-automation-id="connector-modal-nfs-configuration-container">
        <div class="nfsLeft">
            <div class="modal-row">
                <div class="modal-row-column-auto group-label">
                    <label [class.disabled]="isEditConnector" requiredAsterisk [isRequired]="!isEditConnector">Mode:
                    </label>
                </div>
                <div class="modal-row-column-max vertical-middle">
                    <res-custom-radio-button automationId="connector-modal-nfs-read-only" [(ngModel)]="mode"
                        content="Read Only" name="mode" value="READ" [disabled]="isEditConnector" [marginLeft]="10">
                    </res-custom-radio-button>
                    <res-custom-radio-button automationId="connector-modal-nfs-read-write" [(ngModel)]="mode"
                        content="Read/Write" name="mode" value="READWRITE" [disabled]="isEditConnector"
                        [marginLeft]="10"></res-custom-radio-button>
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto group-label">
                    <label [class.disabled]="isEditConnector">PanFS®:</label>
                </div>
                <div class="modal-row-column-auto description">
                    <res-custom-checkbox automationId="connector-modal-nfs-panfs" [(ngModel)]="nfsIsPanFS"
                        [disabled]="isEditConnector" [marginLeft]="10"></res-custom-checkbox>
                </div>
            </div>
        </div>
        <div class="nfsRight">
            <div class="modal-row">
                <div class="modal-row-column-auto group-label">
                    <label requiredAsterisk>Server:</label>
                </div>
                <div class="modal-row-column-max description">
                    <input type="text" id="nfs-server-input" [(ngModel)]="server"
                        placeholder="IP address or domain name ..." on-focusout="getMounts()"
                        (keydown)="noSharesFoundPop?.hide()" data-automation-id="connector-modal-nfs-server-input"
                        (ngModelChange)="onServerChanged()">
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto group-label">
                    <label [class.disabled]="nodes.length === 0 && connectorOperationType === 'New'">Filter:</label>
                </div>
                <div class="modal-row-column-max description">
                    <res-filter [isDisabled]="nodes.length === 0 && connectorOperationType === 'New'"
                        data-automation-id="connector-modal-nfs-path-filter-input" [maxChars]=32
                        [placeholder]='"Filter by share ..."' [callback]="filterData.bind(this)"></res-filter>
                </div>
            </div>
            <div class="modal-row sharesRow">
                <div class="modal-row-column-auto group-label">
                    <label requiredAsterisk>Path:</label>
                </div>
                <div class="modal-row-column-max description shares"
                    [ngClass]="[nodes.length === 0 && connectorOperationType === 'New' ? 'isDisabled': '']"
                    [resBusySpinner]="isLoadingMounts" [message]="isLoadingMountsMsg"
                    data-automation-id="connector-modal-nfs-path-container">
                    <div class="placeHolderShares" *ngIf="!this.noSharesFoundPop?.isOpen && nodes.length === 0">
                        Please specify a server first
                    </div>
                    <div class="placeHolder-shares-error" [hidden]="!this.noSharesFoundPop?.isOpen">
                        <span class="error-popover" data-automation-id="no-shares-found-popover" containerClass="error"
                            container="body" [popover]="noSharesTmpl" triggers="" #noSharesFoundPop="bs-popover"
                            placement="right"></span>
                        <ng-template #noSharesTmpl>
                            <span data-automation-id="connector-modal-no-shares-found-error-label">No shares
                                found.</span>
                            <i class="fa fa-close" (click)="noSharesFoundPop?.hide()"></i>
                        </ng-template>
                    </div>
                    <res-generic-tree automationId="connector-modal-nfs-tree"
                        [loadNodeDataCallback]="loadNodeDataCallback"
                        [selectedNodeChangedCallback]="selectedNodeChangedCallback"></res-generic-tree>
                </div>
            </div>
        </div>
    </div>
    <div class="cifsSection" *ngIf="connectorType === 'CIFS'"
        data-automation-id="connector-modal-cifs-configuration-container">
        <div class="cifsLeft">
            <div class="modal-row">
                <div class="modal-row-column-auto group-label">
                    <label [class.disabled]="isEditConnector" requiredAsterisk [isRequired]="!isEditConnector">Mode:
                    </label>
                </div>
                <div class="modal-row-column-max vertical-middle">
                    <res-custom-radio-button automationId="connector-modal-cifs-read-only" [(ngModel)]="mode"
                        content="Read Only" name="mode" value="READ" [disabled]="isEditConnector">
                    </res-custom-radio-button>
                    <res-custom-radio-button automationId="connector-modal-cifs-read-write" [(ngModel)]="mode"
                        content="Read/Write" name="mode" value="READWRITE" [disabled]="isEditConnector">
                    </res-custom-radio-button>
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto group-label">
                    <label requiredAsterisk>Protocol:
                    </label>
                </div>
                <div class="modal-row-column-max vertical-middle">
                    <res-custom-radio-button automationId="connector-modal-cifs-fqdn-ip" [(ngModel)]="cifsProtocol"
                        content="FQDN / IP" name="cifsProtocol" value="FQDN_OR_IP"></res-custom-radio-button>
                    <res-custom-radio-button automationId="connector-modal-cifs-netbios" [(ngModel)]="cifsProtocol"
                        content="NETBIOS" name="cifsProtocol" value="NETBIOS"></res-custom-radio-button>
                </div>
            </div>
            <div class="modal-row cifs-row">
                <div class="modal-row-column-auto cifs-label">
                    <label requiredAsterisk>Authentication type:
                    </label>
                </div>
                <div class="modal-row-column-max">
                    <select [(ngModel)]="cifsAuthentication" (ngModelChange)="onCifsAuthenticationChange()"
                        data-automation-id="connector-modal-cifs-authentication-type-dropdown">
                        <option *ngFor="let auth of cifsAuthentications | keys" [value]="auth">{{auth}}</option>
                    </select>
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto cifs-label">
                    <label [class.disabled]="cifsAuthentication == 'NONE'" requiredAsterisk
                        [isRequired]="cifsAuthentication != 'NONE'">Username:
                    </label>
                </div>
                <form class="modal-row-column-max">
                    <input type="text" name="username" autocomplete="username" [(ngModel)]="cifsUsername"
                        [disabled]="cifsAuthentication == 'NONE'"
                        data-automation-id="connector-modal-cifs-username-input">
                </form>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto cifs-label">
                    <label [class.disabled]="cifsAuthentication == 'NONE'" requiredAsterisk
                        [isRequired]="cifsAuthentication != 'NONE'">Password:
                    </label>
                </div>
                <form class="modal-row-column-max">
                    <input type="password" name="password" autocomplete="current-password" [(ngModel)]="cifsPassword"
                        [disabled]="cifsAuthentication == 'NONE'"
                        data-automation-id="connector-modal-cifs-password-input"
                        automationId="connector-modal-cifs-password-show-hide-button" resIconSwitch
                        initClass="fa fa-eye" switchClass="fa fa-eye-slash" elementAttributeName="type"
                        elementAttributeValue="text">
                </form>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto cifs-label">
                    <label [class.disabled]="cifsAuthentication == 'NONE'" requiredAsterisk
                        [isRequired]="cifsAuthentication != 'NONE'">Workgroup or domain name:
                    </label>
                </div>
                <div class="modal-row-column-max">
                    <input type="text" [(ngModel)]="cifsWorkgroupOrDomain" [disabled]="cifsAuthentication == 'NONE'"
                        data-automation-id="connector-modal-cifs-workgroup-domain-name-input ">
                </div>
            </div>
            <div class="modal-row cifs-row">
                <div class="modal-row-column-auto">
                    <res-custom-checkbox automationId="connector-modal-support-legacy-mode" [(ngModel)]="cifsLegacyMode"
                        (ngModelChange)="onLegacyModeChange()" content="Support Legacy Mode"></res-custom-checkbox>
                </div>
            </div>
        </div>
        <div class="cifsRight">
            <div class="modal-row">
                <div class="modal-row-column-auto group-label">
                    <label requiredAsterisk>Server:</label>
                </div>
                <div class="modal-row-column-max description">
                    <input type="text" id="cifs-server-input" [(ngModel)]="server" [disabled]="!isCifsValid()"
                        (ngModelChange)="onServerChanged()"
                        [attr.placeholder]="isCifsValid() ? (cifsProtocol == 'FQDN_OR_IP' ? 'IP address or domain name ...' : 'NetBIOS name ...') : 'Please complete the authentication fields'"
                        on-focusout="getMounts()" data-automation-id="connector-modal-cifs-server-input">
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto group-label">
                    <label [class.disabled]="nodes.length === 0 && connectorOperationType === 'New'">Filter:</label>
                </div>
                <div class="modal-row-column-max description">
                    <res-filter [isDisabled]="nodes.length === 0 && connectorOperationType === 'New'"
                        data-automation-id="connector-modal-cifs-path-filter-input" [maxChars]=32
                        [placeholder]='"Filter by share ..."' [callback]="filterData.bind(this)"></res-filter>
                </div>
            </div>
            <div class="modal-row sharesRow">
                <div class="modal-row-column-auto group-label">
                    <label requiredAsterisk>Path:</label>
                </div>
                <div class="modal-row-column-max description shares"
                    [ngClass]="[nodes.length === 0 && connectorOperationType === 'New' ? 'isDisabled': '']"
                    [resBusySpinner]="isLoadingMounts" [message]="isLoadingMountsMsg"
                    data-automation-id="connector-modal-cifs-path-container">
                    <div class="placeHolderShares" *ngIf="nodes.length === 0">
                        Please specify a server first
                    </div>
                    <div class="placeHolder-shares-error" [hidden]="!this.noSharesFoundPop?.isOpen">
                        <span class="error-popover" data-automation-id="no-shares-found-popover" containerClass="error"
                            container="body" [popover]="noSharesTmpl" triggers="" #noSharesFoundPop="bs-popover"
                            placement="right"></span>
                        <ng-template #noSharesTmpl>
                            <span data-automation-id="no-shares-found-pop">No shares found.</span>
                            <i class="fa fa-close" (click)="noSharesFoundPop?.hide()"></i>
                        </ng-template>
                    </div>
                    <res-generic-tree automationId="connector-modal-cifs-tree"
                        [loadNodeDataCallback]="loadNodeDataCallback"
                        [selectedNodeChangedCallback]="selectedNodeChangedCallback"></res-generic-tree>
                </div>
            </div>
        </div>
    </div>
    <div class="msExchangeSection" *ngIf="connectorType === 'Exchange' || connectorType === 'MSSharePoint' || connectorType === ConnectorType.GoogleWorkspace">
        <div class="modal-row">
            <div class="modal-row-column-auto exChange-label">
                <label>Mode: </label>
            </div>
            <div class="modal-row-column-max">
                <label>{{mode ? 'Read Only' : 'Read/Write'}}
                </label>
            </div>
        </div>
        <div class="modal-row exChange-row" *ngIf="connectorType !== ConnectorType.GoogleWorkspace">
            <div class="modal-row-column-auto exChange-label">
                <label for="type" [class.disabled]="isEditConnector">Type:
                </label>
            </div>
            <div class="modal-row-column-max">
                <button data-automation-id="connector-modal-ms-local-button" type="button"
                    [ngClass]="!msOffice365 ? 'btn-group-active' : 'btn-group-default'" (click)="msOffice365 = false"
                    [disabled]="isEditConnector">
                    <div>Local</div>
                    <i class="fa fa-caret-up up-caret-active" [hidden]="!msOffice365"></i>
                </button>
                <button data-automation-id="connector-modal-ms-office-button" type="button"
                    [ngClass]="msOffice365 ? 'btn-group-active' : 'btn-group-default'" (click)="msOffice365 = true"
                    [disabled]="isEditConnector">
                    <div>{{connectorType === 'Exchange' ? 'Office 365' : 'Office 365 Public / Private Sites'}}</div>
                    <i class="fa fa-caret-up up-caret-active" [hidden]="msOffice365"></i>
                </button>
            </div>
        </div>
        <div class="msExchange-config-container">
            <div class="msExchangeLeft">
                <div class="modal-row" *ngIf="!msOffice365 && connectorType !== ConnectorType.GoogleWorkspace">
                    <div class="modal-row-column-auto exChange-label">
                        <label requiredAsterisk>Username: </label>
                    </div>
                    <div class="modal-row-column-max">
                        <input type="text" name="username" autocomplete="username" [(ngModel)]="msUsername"
                            (focusout)="msUsername=msUsername.trim()"
                            data-automation-id="connector-modal-ms-username-input">
                    </div>
                </div>
                <div class="modal-row" *ngIf="!msOffice365 && connectorType !== ConnectorType.GoogleWorkspace">
                    <div class="modal-row-column-auto exChange-label">
                        <label requiredAsterisk>Password: </label>
                    </div>
                    <form #contentForm="ngForm" class="modal-row-column-max">
                        <input type="password" name="password" autocomplete="current-password" ngModel
                            [value]="msPassword" (focusout)="msPassword=msPassword.trim()"
                            data-automation-id="connector-modal-ms-password-input" resIconSwitch initClass="fa fa-eye"
                            (ngModelChange)="onMSPasswordChanged()" switchClass="fa fa-eye-slash"
                            elementAttributeName="type" elementAttributeValue="text" #msPasswordInput
                            name="msPasswordInput">
                    </form>
                </div>
                <div class="modal-row" *ngIf="msOffice365 || connectorType === ConnectorType.GoogleWorkspace">
                    <div class="modal-row-column-auto exChange-label">
                        <label requiredAsterisk>Tenant
                            Domain: </label>
                    </div>
                    <div class="modal-row-column-max">
                        <input type="text" name="msTenantDomain" autocomplete="msTenantDomain"
                            (focusout)="msTenantDomain=msTenantDomain.trim()" [(ngModel)]="msTenantDomain"
                            data-automation-id="connector-modal-ms-tenant-domain-input">
                    </div>
                </div>
                <div class="modal-row" *ngIf="msOffice365 || connectorType === ConnectorType.GoogleWorkspace">
                    <div class="modal-row-column-auto exChange-label">
                        <label requiredAsterisk>{{connectorType === ConnectorType.GoogleWorkspace ? 'Client Email' : 'Application ID'}}: </label>
                    </div>
                    <div class="modal-row-column-max">
                        <input type="text" name="msApplicationId" autocomplete="msApplicationId"
                            [(ngModel)]="msApplicationId" (focusout)="msApplicationId=msApplicationId.trim()"
                            data-automation-id="connector-modal-ms-application-id-input">
                    </div>
                </div>
            </div>
            <div class="msExchangeRight">
                <div class="modal-row" *ngIf="!msOffice365 && connectorType !== ConnectorType.GoogleWorkspace">
                    <div class="modal-row-column-auto exChange-label">
                        <label requiredAsterisk>Domain
                            name: </label>
                    </div>
                    <div class="modal-row-column-max">
                        <input type="text" [(ngModel)]="msDomain" (focusout)="msDomain=msDomain.trim()"
                            data-automation-id="connector-modal-ms-domain-name-input">
                    </div>
                </div>
                <div class="modal-row" *ngIf="!msOffice365 && connectorType !== ConnectorType.GoogleWorkspace">
                    <div class="modal-row-column-auto exChange-label">
                        <label requiredAsterisk>Server: </label>
                    </div>
                    <div class="modal-row-column-max">
                        <input type="text" [(ngModel)]="server" (focusout)="server=server.trim()"
                            data-automation-id="connector-modal-ms-server-input"
                            [attr.placeholder]="'URL or host name ...'">
                    </div>
                </div>
                <div class="modal-row" *ngIf="msOffice365 || connectorType === ConnectorType.GoogleWorkspace">
                    <div class="modal-row-column-auto"
                        [ngClass]="connectorType === ConnectorType.GoogleWorkspace ? 'google-conn-label' : 'exChange-label'">
                        <label requiredAsterisk>{{connectorType === ConnectorType.GoogleWorkspace ? 'Private Key' : 'Application Secret'}}:
                        </label>
                    </div>
                    <div class="modal-row-column-max">
                        <input type="text" name="msApplicationSecret" autocomplete="msApplicationSecret"
                            [(ngModel)]="msApplicationSecret"
                            (focusout)="msApplicationSecret=msApplicationSecret.trim()"
                            data-automation-id="connector-modal-ms-application-secret-input">
                    </div>
                </div>
                <div class="modal-row" *ngIf="msOffice365 && connectorType !== ConnectorType.GoogleWorkspace">
                    <div class="modal-row-column-auto exChange-label">
                        <label>Refresh Token:</label>
                    </div>
                    <div class="modal-row-column-max">
                        <input type="text" name="msRefreshToken" autocomplete="msRefreshToken"
                            [(ngModel)]="msRefreshToken" (focusout)="msRefreshToken=msRefreshToken.trim()"
                            data-automation-id="connector-modal-ms-refresh-token-input">
                        <label *ngIf="msLastUpdatedDateMiliseconds > 0" class="last-updated-label"
                            data-automation-id="connector-modal-ms-last-updated-label">Last Updated:
                            {{msLastUpdatedDateTime}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-template #buttonTemplate>
        <button type="button" data-automation-id="connector-modal-validate-button"
            class="secondary-button validate-button" (click)="validate()" [disabled]="!isValidateEnabled()">
            <i class="fa fa-check fa-icon sizing-icons"></i>Validate</button>
        <div class="validation-error">
            <span class="error-popover" data-automation-id="connector-modal-validation-successful-label"
                containerClass="success" container="body" [popover]="successPopTmpl" triggers=""
                #successPop="bs-popover" placement="left"></span>
            <ng-template #successPopTmpl>
                <span data-automation-id="connector-validate-success-label">Validation successful.</span>
                <i class="fa fa-close" (click)="successPop.hide()"
                    data-automation-id="connector-validate-success-exit-button"></i>
            </ng-template>
        </div>
    </ng-template>
</res-base-modal>